import { useState } from 'react'

import { getFio } from 'helpers/formatText'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { TextField } from 'components/TextField'

import { User } from 'models/user'

import styles from './UsersDeleteModal.module.scss'

const AVATAR_ICON = require('assets/images/png/avatar.png')

interface UsersDeleteModalProps {
  user: User
  disabled: boolean
  onClose: () => void
  onDelete: (user: User, reason: string) => void
}

export const UsersDeleteModal = ({
  user,
  disabled,
  onClose,
  onDelete,
}: UsersDeleteModalProps) => {
  const [reason, setReason] = useState('')

  const handleDelete = () => {
    onDelete(user, reason)
  }

  return (
    <AppModal onClose={onClose} title={`Заблокировать пользователя?`}>
      <div className={styles.container}>
        <div className={styles.avatarContainer}>
          <div className={styles.avatarBg} />
          <div className={styles.avatarImageContainer}>
            <div className={styles.avatarImage}>
              <img src={user.avatar || AVATAR_ICON} alt="" />
            </div>
          </div>
        </div>

        <br />

        <div className={styles.info}>
          <span>ФИО:</span>
          <p>{getFio(user)}</p>
        </div>
        <div className={styles.info}>
          <span>Номер телефона:</span>
          <p>{user.phone}</p>
        </div>
        <div className={styles.info}>
          <span>Регион:</span>
          <p>{user.region?.name}</p>
        </div>

        <TextField
          label="Причина блокировки"
          value={reason}
          onChange={e => setReason(e.currentTarget.value)}
        />

        <br />

        <AppButton
          disabled={disabled || !reason}
          onClick={handleDelete}
          variant="red"
          type="submit"
        >
          Заблокировать
        </AppButton>
      </div>
    </AppModal>
  )
}
